import {
  Condition,
  ConditionGroup,
} from "stores/data/insightAlerts/insightAlertModel";
import { LanguageSymbol } from "types/LanguageSymbol";
import { getUnitsMeasurement } from "util/getUnitsByEnvironmentalVariableId/getUnitsByEnvironmentalVariableId";
import i18n from "../../../../i18n";

export const formatConditions = (
  conditionGroups?: ConditionGroup[],
  language: "pt-BR" | "en" | "es" = LanguageSymbol.PT_BR
): string[] => {

  if (!conditionGroups?.length) {
    if (language === LanguageSymbol.EN) return ["• No conditions defined"];
    if (language === LanguageSymbol.ES) return ["• Sin condiciones definidas"];
    return ["• Nenhuma condição definida"];
  }

  const formattedConditions: string[] = [];

  conditionGroups.forEach((group: ConditionGroup) => {
    const { conditions } = group;
    if (!conditions?.length) return;
    conditions.forEach((condition: Condition) => {
      const { environmentalVariable, environmentalVariableId, value } =
        condition;

      const units = getUnitsMeasurement(environmentalVariableId, language);

      const baseValue = value;
      const minValue = baseValue * 0.8;
      const maxValue = baseValue * 1.2;

      const formatNumber = (num: number): string => {
        if (units === "knots" || environmentalVariable === "visibility") {
          return num.toFixed(0);
        }
        return num.toFixed(1);
      };

      const min = formatNumber(minValue);
      const max = formatNumber(maxValue);

      let fallbackText: string;
      if (language === LanguageSymbol.EN) {
        fallbackText = `• ${i18n.t('forecastChart.forecastTable.environmentalVariableEnum.' + environmentalVariable)} between ${min} and ${max} ${units}`;
      } else if (language === LanguageSymbol.ES) {
        fallbackText = `• ${i18n.t('forecastChart.forecastTable.environmentalVariableEnum.' + environmentalVariable)} entre ${min} y ${max} ${units}`;
      } else {
        fallbackText = `• ${i18n.t('forecastChart.forecastTable.environmentalVariableEnum.' + environmentalVariable)} entre ${min} e ${max} ${units}`;
      }
      formattedConditions.push(fallbackText);

    });
  });

  return formattedConditions;
};
